import React from "react";
import { CheckCircleIcon, MinesCircleIcon } from "@pd/pd-ui-kit";

import { NOTIFICATIONS } from "~/constans/notifications";
import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { Select } from "~/shared/ui/Select";

import s from "./s.less";

interface SelectIconIProps {
  isAcceptance?: boolean;
  negativeCheckCamera?: (prop: string) => void;
  handleAcceptCamera: (data: any) => void;
  cameraId: string;
  readOnly?: boolean;
  externalCameraRejectReason?: string;
}

const SelectIcon = ({
  isAcceptance,
  handleAcceptCamera,
  cameraId,
  readOnly,
  externalCameraRejectReason,
}: SelectIconIProps) => {
  const setURLParams = useURLParamsSetter();
  const [addNotificationMutation] = useAddNotificationMutation({});

  const checkCamera = (prop: string) => {
    if (prop === "rejected") {
      setURLParams({ openModalReject: prop });
      sessionStorage.setItem("cameraId", cameraId);
    } else {
      if (externalCameraRejectReason) {
        addNotificationMutation({
          variables: {
            type: NOTIFICATIONS.error,
            content: externalCameraRejectReason,
          },
        });
      } else {
        handleAcceptCamera(cameraId);
      }
    }
  };

  const getDefaultValue = () => {
    if (isAcceptance === true) return "confirmed";
    if (isAcceptance === false) return "rejected";
    return null;
  };

  const customOptions = [
    {
      className: s.option,
      label: "Подтверждено",
      value: "confirmed",
      disabled: readOnly,
      icon: <CheckCircleIcon size={14} fill="#00BB6D" />,
    },
    {
      className: s.option,
      label: "Отклонено",
      value: "rejected",
      icon: <MinesCircleIcon size={14} fill="#F21B1B" />,
    },
  ];

  if (readOnly) {
    const statusOption = customOptions.find(
      (opt) => opt.value === getDefaultValue(),
    );
    return (
      <div className={s.readOnlyStatus}>
        {statusOption ? (
          <>
            {statusOption.icon}
            <span>{statusOption.label}</span>
          </>
        ) : (
          <span className={s.readOnlyStatusEmpty}>Не выбран</span>
        )}
      </div>
    );
  }

  return (
    <div onClick={(e) => e.stopPropagation()} className={s.select}>
      <Select
        style={{ width: "150px", fontSize: "11px" }}
        exp={true}
        placeholder="Не выбрано"
        options={customOptions}
        defaultValue={getDefaultValue}
        value={getDefaultValue()}
        onSelect={checkCamera}
        variant={"borderless"}
      />
    </div>
  );
};

export default SelectIcon;
